import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import Validator from 'validatorjs';
import { Button, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { FormControl } from '../../../../../facturotopia';
import MonedaSuggestions from '../../../../catalogs/MonedaSuggestions';
import UnidadDeMedidaSuggestions from '../../../../catalogs/UnidadDeMedidaSuggestions';
import CartaPorteClienteManager from '../../../../catalogs/managers/CartaPorteClienteManager';
import CartaPorteCatalogoManager from '../../../../catalogs/managers/CartaPorteCatalogoManager';
import CartaPorteProductoServicioSuggestions from './suggestions/CartaPorteProductoServicioSuggestions';
import CartaPorteMaterialPeligrosoSuggestions from './suggestions/CartaPorteMaterialPeligrosoSuggestions';
import ComercioExteriorFraccionArancelariaSuggestions from '../../../../catalogs/ComercioExteriorFraccionArancelariaSuggestions';

class CartaPorteMercanciaForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      show: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  async componentDidMount() {
    const tipoEmbalaje = await CartaPorteCatalogoManager.get('c_cp_tipo_embalaje');
    const TipoMateria = await CartaPorteCatalogoManager.get('c_cp_tipo_materia');
    const SectorCOFEPRIS = await CartaPorteCatalogoManager.get('c_cp_sector_cofepris');
    const FormaFarmaceutica = await CartaPorteCatalogoManager.get('c_cp_forma_farmaceutica');
    const CondicionesEspTransp = await CartaPorteCatalogoManager.get('c_cp_condiciones_especiales');

    const { mercancias } = CartaPorteClienteManager.get('carta-porte');

    let catalogos = {};

    catalogos.tipoEmbalaje = this.getCatalogo(tipoEmbalaje);
    catalogos.TipoMateria = this.getCatalogo(TipoMateria);
    catalogos.SectorCOFEPRIS = this.getCatalogo(SectorCOFEPRIS);
    catalogos.FormaFarmaceutica = this.getCatalogo(FormaFarmaceutica);
    catalogos.CondicionesEspTransp = this.getCatalogo(CondicionesEspTransp);
    catalogos.ClienteMercancias = this.getSortedCatalogoCliente(mercancias, 'descripcion', 'descripcion');

    this.setState({
      catalogos,
    });
  }

  rules(data) {
    return {
      BienesTransp: ['required', 'string'],
      ClaveSTCC: ['min:6'],
      Descripcion: ['required', 'string', 'min:1', 'max:1000'],
      Cantidad: ['required', 'min:0.000001'],
      ClaveUnidad: ['required', 'string'],
      Unidad: ['string', 'min:1', 'max:20'],
      Dimensiones: ['string'],
      MaterialPeligroso: ['string', 'in:Sí,No'],
      CveMaterialPeligroso: ['string'],
      Embalaje: ['string'],
      DescripEmbalaje: ['string', 'min:1', 'max:100'],
      PesoEnKg: ['required', 'min:0.001'],
      ValorMercancia: ['min:0.000000'],
      Moneda: ['string'],
      FraccionArancelaria: ['string'],
      UUIDComercioExt: ['string'],
      SectorCOFEPRIS: [
        // 'catCartaPorte:c_SectorCOFEPRIS',
        'string',
      ],
      NombreIngredienteActivo: ['string', 'min:1', 'max:1000', 'regex:/^[^|]{1,1000}$/'],
      NomQuimico: ['string', 'min:1', 'max:150', 'regex:/^[^|]{1,150}$/'],
      DenominacionGenericaProd: ['string', 'min:1', 'max:50', 'regex:/^[^|]{1,50}$/'],
      DenominacionDistintivaProd: ['string', 'min:1', 'max:50', 'regex:/^[^|]{1,50}$/'],
      Fabricante: ['string', 'min:1', 'max:240', 'regex:/^[^|]{1,240}$/'],
      FechaCaducidad: ['date'],
      LoteMedicamento: ['string', 'min:1', 'max:10', 'regex:/^[^|]{1,10}$/'],
      FormaFarmaceutica: [
        // 'catCartaPorte:c_FormaFarmaceutica',
        'string',
      ],
      CondicionesEspTransp: [
        // 'catCartaPorte:c_CondicionesEspeciales',
        'string',
      ],
      RegistroSanitarioFolioAutorizacion: ['string', 'min:1', 'max:15', 'regex:/^[^|]{1,15}$/'],
      PermisoImportacion: ['string', 'min:1', 'max:6', 'regex:/^[^|]{1,6}$/'],
      FolioImpoVUCEM: ['string', 'min:1', 'max:25', 'regex:/^[^|]{1,25}$/'],
      NumCAS: ['string', 'min:1', 'max:15', 'regex:/^[^|]{1,15}$/'],
      RazonSocialEmpImp: ['string', 'min:1', 'max:80', 'regex:/^[^|]{1,80}$/'],
      NumRegSanPlagCOFEPRIS: ['string', 'min:1', 'max:60', 'regex:/^[^|]{1,60}$/'],
      DatosFabricante: ['string', 'min:1', 'max:600', 'regex:/^[^|]{1,600}$/'],
      DatosFormulador: ['string', 'min:1', 'max:600', 'regex:/^[^|]{1,600}$/'],
      DatosMaquilador: ['string', 'min:1', 'max:600', 'regex:/^[^|]{1,600}$/'],
      UsoAutorizado: ['string', 'min:1', 'max:1000', 'regex:/^[^|]{1,1000}$/'],
      TipoMateria: [
        // 'catCartaPorte:c_TipoMateria',
        'string',
      ],
      DescripcionMateria: ['string', 'min:1', 'max:50', 'regex:/^[^|]{1,50}$/'],
    };
  }

  getCatalogo = (values) => {
    if (!!values) {
      const sorted = _.sortBy(
        values.map((item) => {
          return {
            label: item.descripcion,
            value: item.clave,
          };
        }),
        'label'
      );

      return [
        {
          label: 'Selecciona',
          value: '',
        },
      ].concat(sorted);
    }
  };

  getSortedCatalogoCliente = (values, label, id) => {
    if (!values) {
      return [];
    }

    return _.sortBy(
      values.map((item) => {
        return {
          label: item[label],
          value: item[id],
          clave_prod_serv: item.clave_prod_serv,
          clave_stcc: item.clave_stcc,
          descripcion: item.descripcion,
          cantidad: item.cantidad,
          clave_unidad: item.clave_unidad,
          unidad: item.unidad,
          dimensiones: item.dimensiones,
          material_peligroso: item.material_peligroso,
          clave_material_peligroso: item.clave_material_peligroso,
          embalaje: item.embalaje,
          descripcion_embalaje: item.descripcion_embalaje,
          peso_en_kilogramos: item.peso_en_kilogramos,
          valor_mercancia: item.valor_mercancia,
          moneda: item.moneda,
          fraccion_arancelaria: item.fraccion_arancelaria,
          uuid_comercio_exterior: item.uuid_comercio_exterior,
          detalle_unidad_peso: item.detalle_unidad_peso,
          detalle_peso_bruto: item.detalle_peso_bruto,
          detalle_peso_neto: item.detalle_peso_neto,
          detalle_peso_tara: item.detalle_peso_tara,
          detalle_numero_piezas: item.detalle_numero_piezas,
        };
      }),
      'descripcion'
    );
  };

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value,
    };

    const validator = this.validate(data);

    this.props.onFormDataChange(
      {
        ...data,
      },
      validator.passes()
    );
  };

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  }

  handleOnMercanciasChange = (value) => {
    let data = {
      ...this.state.data,
      ...value,
    };

    if (!_.isEmpty(value)) {
      data = {
        ...this.state.data,
        ClienteMercancias: value.descripcion.toString(),
        BienesTransp: value.clave_prod_serv.toString(),
        ClaveSTCC: value.clave_stcc.toString(),
        Descripcion: value.descripcion.toString(),
        Cantidad: value.cantidad.toString(),
        ClaveUnidad: value.clave_unidad.toString(),
        Unidad: value.unidad.toString(),
        Dimensiones: value.dimensiones.toString(),
        MaterialPeligroso: value.material_peligroso.toString(),
        CveMaterialPeligroso: value.clave_material_peligroso.toString(),
        Embalaje: value.embalaje.toString(),
        DescripEmbalaje: value.descripcion_embalaje.toString(),
        PesoEnKg: value.peso_en_kilogramos.toString(),
        ValorMercancia: value.valor_mercancia.toString(),
        Moneda: value.moneda.toString(),
        FraccionArancelaria: value.fraccion_arancelaria.toString(),
        UUIDComercioExt: value.uuid_comercio_exterior.toString(),
        DetalleMercancia: {
          UnidadPesoMerc: value.detalle_unidad_peso.toString(),
          PesoBruto: value.detalle_peso_bruto.toString(),
          PesoNeto: value.detalle_peso_neto.toString(),
          PesoTara: value.detalle_peso_tara.toString(),
          NumPiezas: value.detalle_numero_piezas.toString(),
        },
      };
    }

    this.handleOnChange(data);
  };

  handleOnSuggestionSelect = (name) => (item) => {
    let value = '';

    if (name === 'FraccionArancelaria') {
      value = item ? item.fraccion_arancelaria : '';
    } else {
      value = item ? item.clave : '';
    }

    let values = {
      [name]: value,
    };

    this.handleOnChange(values);
  };

  handleOnRefreshData = () => {
    this.setState({
      data: {},
      isValid: false,
      pedimentos: false,
      cantidad_transporta: false,
      guias_identificacion: false,
    });
  };

  render() {
    const { catalogos = {} } = this.state;

    const { data } = this.props;
    const rules = this.rules(data);

    return (
      <>
        <Row className="pb-2">
          <Col
            sm
            md={11}
          >
            <FormControl
              type="ahead"
              label="Catálogo Mercancías"
              id="ClienteMercancias"
              name="ClienteMercancias"
              help=""
              value={data.ClienteMercancias}
              placeholder={data.ClienteMercancias}
              options={catalogos.ClienteMercancias}
              onSelect={this.handleOnMercanciasChange}
            />
          </Col>

          <Col
            sm
            md={1}
            className="text-right"
            style={{ marginTop: '28px' }}
          >
            <Button
              size="lg"
              variant="secondary"
              onClick={this.handleOnRefreshData}
            >
              <FontAwesomeIcon icon={['fas', 'trash']} />
            </Button>
          </Col>
        </Row>

        <Row className="pb-3">
          <Col>
            <CartaPorteProductoServicioSuggestions
              name="BienesTransp"
              id="BienesTransp"
              label="Bienes Transportados"
              rules={rules.BienesTransp}
              value={data.BienesTransp}
              onSelect={this.handleOnSuggestionSelect('BienesTransp')}
            />
          </Col>
        </Row>

        <Row>
          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Clave STCC"
              name="ClaveSTCC"
              placeholder=""
              help=""
              minLength="6"
              maxLength="7"
              rules={rules.ClaveSTCC}
              value={data.ClaveSTCC}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Descripción"
              name="Descripcion"
              placeholder=""
              help=""
              minLength="1"
              maxLength="1000"
              rules={rules.Descripcion}
              value={data.Descripcion}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Cantidad"
              name="Cantidad"
              placeholder=""
              help=""
              rules={rules.Cantidad}
              value={data.Cantidad}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <UnidadDeMedidaSuggestions
              label="Clave Unidad"
              name="ClaveUnidad"
              rules={rules.ClaveUnidad}
              value={data.ClaveUnidad}
              onSelect={this.handleOnSuggestionSelect('ClaveUnidad')}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Unidad"
              name="Unidad"
              placeholder=""
              help=""
              minLength="1"
              maxLength="20"
              rules={rules.Unidad}
              value={data.Unidad}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Dimensiones"
              name="Dimensiones"
              placeholder=""
              help=""
              rules={rules.Dimensiones}
              value={data.Dimensiones}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="select"
              label="Material Peligroso"
              name="MaterialPeligroso"
              placeholder=""
              help=""
              minLength="2"
              maxLength="2"
              rules={rules.MaterialPeligroso}
              value={data.MaterialPeligroso}
              options={MaterialPeligroso}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <CartaPorteMaterialPeligrosoSuggestions
              label="Clave Material Peligroso"
              name="CveMaterialPeligroso"
              rules={rules.CveMaterialPeligroso}
              value={data.CveMaterialPeligroso}
              onSelect={this.handleOnSuggestionSelect('CveMaterialPeligroso')}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="select"
              label="Embalaje"
              name="Embalaje"
              placeholder=""
              help=""
              rules={rules.Embalaje}
              value={data.Embalaje}
              options={catalogos.tipoEmbalaje}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Descripción Embalaje"
              name="DescripEmbalaje"
              placeholder=""
              help=""
              minLength="1"
              maxLength="100"
              rules={rules.DescripEmbalaje}
              value={data.DescripEmbalaje}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Peso en Kilogramo"
              name="PesoEnKg"
              placeholder=""
              help=""
              rules={rules.PesoEnKg}
              value={data.PesoEnKg}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Valor Mercancía"
              name="ValorMercancia"
              placeholder=""
              help=""
              rules={rules.ValorMercancia}
              value={data.ValorMercancia}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <MonedaSuggestions
              label="Moneda"
              name="Moneda"
              rules={rules.Moneda}
              value={data.Moneda}
              onSelect={this.handleOnSuggestionSelect('Moneda')}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <ComercioExteriorFraccionArancelariaSuggestions
              label="Fracción Arancelaria"
              name="FraccionArancelaria"
              rules={rules.FraccionArancelaria}
              value={data.FraccionArancelaria}
              onSelect={this.handleOnSuggestionSelect('FraccionArancelaria')}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="UUID Comercio Exterior"
              name="UUIDComercioExt"
              placeholder=""
              help=""
              minLength="16"
              maxLength="36"
              rules={rules.UUIDComercioExt}
              value={data.UUIDComercioExt}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="select"
              label="Sector COFEPRIS"
              name="SectorCOFEPRIS"
              placeholder=""
              help=""
              minLength="3"
              maxLength="3"
              rules={rules.SectorCOFEPRIS}
              value={data.SectorCOFEPRIS}
              options={catalogos.SectorCOFEPRIS}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Número Registro Sanitario Plaguicidas COFEPRIS"
              name="NumRegSanPlagCOFEPRIS"
              placeholder=""
              help=""
              minLength="1"
              maxLength="60"
              rules={rules.NumRegSanPlagCOFEPRIS}
              value={data.NumRegSanPlagCOFEPRIS}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="date-picker"
              id="FechaCaducidad"
              label="Fecha Caducidad"
              name="FechaCaducidad"
              maxDate={moment().add(5, 'years').toDate()}
              rules={rules.FechaCaducidad}
              value={data.FechaCaducidad}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Nombre Químico"
              name="NomQuimico"
              placeholder=""
              help=""
              minLength="1"
              maxLength="150"
              rules={rules.NomQuimico}
              value={data.NomQuimico}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Denominacion Generica del Producto"
              name="DenominacionGenericaProd"
              placeholder=""
              help=""
              minLength="1"
              maxLength="50"
              rules={rules.DenominacionGenericaProd}
              value={data.DenominacionGenericaProd}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Denominación Distintiva del Producto"
              name="DenominacionDistintivaProd"
              placeholder=""
              help=""
              minLength="1"
              maxLength="50"
              rules={rules.DenominacionDistintivaProd}
              value={data.DenominacionDistintivaProd}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Lote Medicamento  "
              name="LoteMedicamento"
              placeholder=""
              help=""
              minLength="1"
              maxLength="10"
              rules={rules.LoteMedicamento}
              value={data.LoteMedicamento}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="select"
              label="Forma Farmacéutica"
              name="FormaFarmaceutica"
              placeholder=""
              help=""
              minLength="3"
              maxLength="3"
              rules={rules.FormaFarmaceutica}
              value={data.FormaFarmaceutica}
              options={catalogos.FormaFarmaceutica}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="select"
              label="Condiciones Especiales Transporte"
              name="CondicionesEspTransp"
              placeholder=""
              help=""
              minLength="3"
              maxLength="3"
              rules={rules.CondicionesEspTransp}
              value={data.CondicionesEspTransp}
              options={catalogos.CondicionesEspTransp}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Registro Sanitario Folio Autorización"
              name="RegistroSanitarioFolioAutorizacion"
              placeholder=""
              help=""
              minLength="1"
              maxLength="15"
              rules={rules.RegistroSanitarioFolioAutorizacion}
              value={data.RegistroSanitarioFolioAutorizacion}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Permiso de Importación"
              name="PermisoImportacion"
              placeholder=""
              help=""
              minLength="1"
              maxLength="6"
              rules={rules.PermisoImportacion}
              value={data.PermisoImportacion}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Folio de Importación VUCEM"
              name="FolioImpoVUCEM"
              placeholder=""
              help=""
              minLength="1"
              maxLength="25"
              rules={rules.FolioImpoVUCEM}
              value={data.FolioImpoVUCEM}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Número CAS"
              name="NumCAS"
              placeholder=""
              help=""
              minLength="1"
              maxLength="15"
              rules={rules.NumCAS}
              value={data.NumCAS}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Razón Social Empresa Importadora"
              name="RazonSocialEmpImp"
              placeholder=""
              help=""
              minLength="1"
              maxLength="80"
              rules={rules.RazonSocialEmpImp}
              value={data.RazonSocialEmpImp}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="select"
              label="Tipo Materia"
              name="TipoMateria"
              placeholder=""
              help=""
              minLength="3"
              maxLength="3"
              rules={rules.TipoMateria}
              value={data.TipoMateria}
              options={catalogos.TipoMateria}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Descripción Materia"
              name="DescripcionMateria"
              placeholder=""
              help=""
              minLength="1"
              maxLength="50"
              rules={rules.DescripcionMateria}
              value={data.DescripcionMateria}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>

        <Row>
          <Col
            sm
            md={12}
          >
            <FormControl
              as="textarea"
              label="Fabricante"
              name="Fabricante"
              placeholder=""
              help=""
              rows="3"
              minLength="1"
              maxLength="250"
              rules={rules.Fabricante}
              value={data.Fabricante}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>

        <Row>
          <Col
            sm
            md={12}
          >
            <FormControl
              as="textarea"
              label="Datos del Fabricante"
              name="DatosFabricante"
              placeholder=""
              help=""
              rows="3"
              minLength="1"
              maxLength="600"
              rules={rules.DatosFabricante}
              value={data.DatosFabricante}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>

        <Row>
          <Col
            sm
            md={12}
          >
            <FormControl
              as="textarea"
              label="Nombre Ingrediente Activo"
              name="NombreIngredienteActivo"
              placeholder=""
              help=""
              rows="3"
              minLength="1"
              maxLength="1000"
              rules={rules.NombreIngredienteActivo}
              value={data.NombreIngredienteActivo}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>

        <Row>
          <Col
            sm
            md={12}
          >
            <FormControl
              as="textarea"
              label="Datos del Formulador"
              name="DatosFormulador"
              placeholder=""
              help=""
              rows="3"
              minLength="1"
              maxLength="600"
              rules={rules.DatosFormulador}
              value={data.DatosFormulador}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>

        <Row>
          <Col
            sm
            md={12}
          >
            <FormControl
              as="textarea"
              label="Datos del Maquilador"
              name="DatosMaquilador"
              placeholder=""
              help=""
              rows="3"
              minLength="1"
              maxLength="600"
              rules={rules.DatosMaquilador}
              value={data.DatosMaquilador}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>

        <Row>
          <Col
            sm
            md={12}
          >
            <FormControl
              as="textarea"
              label="Uso Autorizado"
              name="UsoAutorizado"
              placeholder=""
              help=""
              rows="3"
              minLength="1"
              maxLength="1000"
              rules={rules.UsoAutorizado}
              value={data.UsoAutorizado}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>
      </>
    );
  }
}

const MaterialPeligroso = [
  {
    label: 'selecciona',
    value: '',
  },
  {
    label: 'Sí',
    value: 'Sí',
  },
  {
    label: 'No',
    value: 'No',
  },
];

export default CartaPorteMercanciaForm;
